import * as React from 'react'

import Moment from 'react-moment'

import { Employee } from '../../../lib/interfaces/Employee.interface'
import { employmentStatusToString } from 'src/lib/interfaces/EmploymentStatus.interface'

interface EmployeeCardProps {
  employee: Employee
  onSelectEmployee: (Employee) => void
}


class EmployeeCard extends React.PureComponent<EmployeeCardProps> {
  
  constructor(props) {
    super(props)
    this.handleSelectEmployee = this.handleSelectEmployee.bind(this)
  }

  get employmentStatusText() {
    const { employee } = this.props
    return employmentStatusToString(employee.employmentStatus) || '-'
  }

  handleSelectEmployee() {
    const { employee } = this.props
    this.props.onSelectEmployee(employee)
  }

  render() {
    const { employee } = this.props

    return (
      <div className="ggcard-employee clickable" onClick={this.handleSelectEmployee}>
        <div className="card-header bg-transparent">
          <div className="row">
            <div className="col-9">                      
              <span className="ggcard-employee-name">
                {employee.firstName} {employee.lastName}
              </span>                    
            </div>
            <div className="col-3">                      
              <span className="ggbadge badge-gray float-right">
                {employee.location && employee.location.code}
              </span>
            </div>
          </div>                  
        </div>
        <div className="card-body">
          <ul className="list-unstyled">
            <li>Status: {this.employmentStatusText}</li>
            <li>Hire date: {employee.hireDate ? <Moment date={employee.hireDate} format="MM.DD.YYYY" /> : '-'}</li>
            <li>Gender: {employee.gender || '-'}</li>
          </ul>        
        </div>
      </div> 
    )
  }
}

export default EmployeeCard


// WEBPACK FOOTER //
// ./src/routes/employees/components/EmployeeCard.component.tsx